// API configuration for Experts Communication frontend

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:3000';
    }
  }

  return 'https://api.expertdesignhub.com';
};

export const API_BASE_URL = getApiBaseUrl();
export const EXPERTSCOM_API_URL = `${API_BASE_URL}/expertscom`;

const config = {
  API_BASE_URL,
  EXPERTSCOM_API_URL,
};

export default config;
